import axios from "axios";
import { kkmh } from "@/assets/js/common/kkmh_wk";


let baseUrl = "/";

function StringIfy(obj) {
    if (!obj) {
        return "";
    }

    let val = typeof obj === "object" && isNaN(obj.length);
    if (!val) {
        return "";
    }

    let str = "";
    for (let key in obj) {
        let value = obj[key];
        if (str == "") {
            str += `${key}=${value}`;
        } else {
            str += `&${key}=${value}`;
        }
    }

    return str;
}

function getUrl(url, yapimockurl) {
    if (url.indexOf("http") > -1) {
        return url;
    } else {
        return /mock=true/.test(location.href) && yapimockurl ? yapimockurl : (url.charAt(0) == "/" ? "" : baseUrl) + url;
    }
}
function getHeaders(headers) {
    let sysinfo = window.__gvalkkmh && window.__gvalkkmh.sys;
    if (sysinfo && sysinfo.device_id && JSON.stringify(headers) == "{}") {
        headers = {
            "X-Device": sysinfo.device_id,
            "Muid": sysinfo.muid, //android
            "App-Info": sysinfo.app_info,
            "Package-Id": sysinfo.package_id, //包名
        };
    }
    let user_agent_mini = decodeURIComponent(kkmh.qs()["useragent"] ? kkmh.qs()["useragent"] : "");
    headers = { ...headers, ...{ "User-Agent-Mini": user_agent_mini } };
    return headers;
}
/**
 * ** Get(Post) 请求封装
 * @ url 请求地址
 * @ data 发送的数据
 * @ sources 用于停止当前请求
 * @ timeout 请求超时时间
 * @ apiUrl 修改默认 baseURL
 * */
const Get = function ({ baseURL = "", url = "", data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = "" } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);
    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken; //停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });
    data = data ? data : {};
    data.success = 1;

    axios.defaults.baseURL = baseURL; // xubowei 添加原因： 增长落地页 服务端接口采用CORS允许全部跨域的方式，需要我们手动设置baseURL。 影响：normal/landpage/topic

    return axios.get(
        url,
        {
            params: data,
            cancelToken: token, //停止请求使用
            timeout: timeout, //请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const Post = function ({ baseURL = "", url = "", data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = "" } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);

    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken;//停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });

    data = data ? data : {};

    axios.defaults.baseURL = baseURL;  // xubowei 添加原因： 增长落地页 服务端接口采用CORS允许全部跨域的方式，需要我们手动设置baseURL。 影响：normal/landpage/topic

    return axios.post(
        url,
        StringIfy(data),
        {
            cancelToken: token, //停止请求使用
            timeout: timeout,//请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const Delete = function ({ url = "", data = {}, sources = [], timeout = 1000 * 10, headers = {}, yapimockurl = "" } = {}) {

    //配置请求地址
    url = getUrl(url, yapimockurl);
    sources = Array.isArray(sources) ? sources : []; //存储请求信息,用于停止请求
    let CancelToken = axios.CancelToken; //停止请求使用
    let token = new CancelToken(function executor(cancel) {
        sources.push(cancel);
    });
    data = data ? data : {};
    data.success = 1;
    return axios.delete(
        url,
        {
            params: data,
            cancelToken: token, //停止请求使用
            timeout: timeout, //请求超时设置
            headers: getHeaders(headers),
        }
    );
};

const $Http = axios;

export {
    StringIfy,
    Get,
    Post,
    Delete,
    $Http
};




// WEBPACK FOOTER //
// ./src/api/axios.config.js